import { render, staticRenderFns } from "./CdkImage.vue?vue&type=template&id=cd38b5a4&scoped=true&"
import script from "./CdkImage.vue?vue&type=script&lang=ts&"
export * from "./CdkImage.vue?vue&type=script&lang=ts&"
import style0 from "./CdkImage.vue?vue&type=style&index=0&id=cd38b5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38b5a4",
  null
  
)

export default component.exports